import { useSelector } from 'react-redux';
import { selectCurrentMessage } from './selectors';
import { AppMessage } from './types';

export function useAppMessage(): AppMessage | null {
    return useSelector(selectCurrentMessage);
}
